<template>
  <div class="details details--full mt-80px">
    <DetailsToolbar
      :title="getDetailsTitle"
      :blocked="isBlocked"
      :table-name="tableName"
      :prev-route="prevRoute"
    >
      <v-spacer />
      <ActionButtons
        :actions="getDetailsActions"
        :item="clientAppOrder"
      />
    </DetailsToolbar>
    <div class="px-4">
      <SectionsWrapper
        :details="details"
        :data="clientAppOrder"
      >
        <template #default="{ detail, slotData }">
          <component
            :is="detail.component || 'DetailsSection'"
            :detail="getSectionFields(detail)"
            :data="slotData"
            :list="nestedSection(detail.multiple)"
          />
        </template>
      </SectionsWrapper>
    </div>
  </div>
</template>

<script>
import SectionsWrapper from './Sections/SectionsWrapper'
import webSocketMixin from '../../mixins/webSocketMixin'
import navigateBackMixin from '../../mixins/navigateBackMixin'
import singleViewMixin from '../../mixins/singleViewMixin'
import { mapState, mapActions } from 'vuex'

export default {
  mixins: [
    webSocketMixin,
    navigateBackMixin, // prevRoute,
    singleViewMixin, // ActionButtons, DetailsToolbar, DetailsSection, DetailsSectionList, getDetailsActions,
    // getDetailsTitle, isBlocked, details, configured, setDetails, getSectionFields, nestedSection
  ],
  components: {
    SectionsWrapper
  },
  data: () => ({
    tableName: 'clientAppOrders'
  }),
  provide () {
    return {
      notWebSocketHandled: false
    }
  },
  channels: {
    ClientAppOrderShowChannel: { received (data) { this.captureSingleChange(data) } }
  },
  computed: {
    ...mapState({
      clientAppOrder: state => state.clientAppOrder.entity, // webSocketMixin purpose
      entity: state => state.clientAppOrder.entity // singleViewMixin purpose
    }),
  },
  mounted () {
    const { id } = this.$route.params
    this.getSingleClientAppOrder(id)
      .then(() => {
        this.setDetails()
      })
    this.subscribeSocket('ClientAppOrderShowChannel', { clientAppOrderId: id })
  },
  beforeDestroy () {
    this.unsubscribeSocket('ClientAppOrderShowChannel')
    this.clearSingleClientAppOrder()
  },
  methods: {
    ...mapActions({
      clearSingleClientAppOrder: 'clientAppOrder/clearSingleClientAppOrder',
      getSingleClientAppOrder: 'clientAppOrder/getSingleClientAppOrder'
    }),
  }
}
</script>
